import { o_global } from "../../common/namespaces";
import { eventQBus } from "./q-bus/index.js";

/*                                              */
o_global.eventQBus ||= eventQBus();
o_global.events ||= () => o_global.eventQBus as never;
